import MuiBreadcrumbs, { type BreadcrumbsProps } from "@mui/material/Breadcrumbs";

export type { BreadcrumbsProps };

export function Breadcrumbs(props: BreadcrumbsProps) {
  return <MuiBreadcrumbs {...props} />;
}
